import FormKeys from 'forms-utils-lib/constants/formDefinition/FormKeys';
import defaultForm from 'forms-utils-lib/formDefinition/constants/defaultForm';
import parseStyle from 'forms-utils-lib/formDefinition/lib/parseStyle';
const createForm = (args = {}) => {
  const unparsedStyle = args && args[FormKeys.STYLE] || undefined;
  const parsedStyle = parseStyle(unparsedStyle);
  return Object.assign({}, defaultForm, args, {
    [FormKeys.STYLE]: parsedStyle
  });
};
export default createForm;